// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.session.ClientSessionConfiguration
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { PollConfiguration } from "abweb/dto/async/PollConfiguration";
import { ProxyType } from "abweb/dto/generated/proxy/ProxyType";
import { ActivationConfiguration } from "abweb/dto/generated/session/ActivationConfiguration";
import { ProxyConfiguration } from "abweb/dto/generated/session/ProxyConfiguration";
import { InactivityConfiguration } from "abweb/dto/inactivity/InactivityConfiguration";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class ClientSessionConfiguration {
  static createClientSessionConfiguration(abHelpURL, activationConfiguration, id, inactivityConfiguration, localServices, pollConfiguration, proxyConfiguration) {
    const retVal = new ClientSessionConfiguration();
    retVal.initClientSessionConfiguration(abHelpURL, activationConfiguration, id, inactivityConfiguration, localServices, pollConfiguration, proxyConfiguration);
    return retVal;
  }

  /** Do NOT invoke directly, instead use strongly typed createClientSessionConfiguration factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawads.ClientSessionConfiguration";
  }
  initFromJson(json, deserializeContext) {
    this.initClientSessionConfiguration(json.abHelpURL != null ? json.abHelpURL : null, TSOGUtils.decodeObject(json.activationConfiguration, ActivationConfiguration, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "activationConfiguration")), json.id != null ? json.id : null, TSOGUtils.decodeObject(json.inactivityConfiguration, InactivityConfiguration, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "inactivityConfiguration")), json.localServices != null ? TSOGUtils.decodeEnumArray(json.localServices, ProxyType) : null, TSOGUtils.decodeObject(json.pollConfiguration, PollConfiguration, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "pollConfiguration")), TSOGUtils.decodeObject(json.proxyConfiguration, ProxyConfiguration, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "proxyConfiguration")));
  }
  initClientSessionConfiguration(abHelpURL, activationConfiguration, id, inactivityConfiguration, localServices, pollConfiguration, proxyConfiguration) {
    this._abHelpURL = abHelpURL;
    this._activationConfiguration = activationConfiguration;
    this._id = id;
    this._inactivityConfiguration = inactivityConfiguration;
    this._localServices = localServices;
    this._pollConfiguration = pollConfiguration;
    this._proxyConfiguration = proxyConfiguration;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    if (this._abHelpURL != null) {
      retVal["abHelpURL"] = this._abHelpURL;
    }
    if (this._activationConfiguration != null) {
      retVal["activationConfiguration"] = TSOGUtils.toTSOGNativeObject(this._activationConfiguration, serializeContext);
    }
    retVal["id"] = this._id;
    retVal["inactivityConfiguration"] = TSOGUtils.toTSOGNativeObject(this._inactivityConfiguration, serializeContext);
    if (this._localServices != null) {
      retVal["localServices"] = TSOGUtils.toTSOGArray(this._localServices, serializeContext);
    }
    retVal["pollConfiguration"] = TSOGUtils.toTSOGNativeObject(this._pollConfiguration, serializeContext);
    if (this._proxyConfiguration != null) {
      retVal["proxyConfiguration"] = TSOGUtils.toTSOGNativeObject(this._proxyConfiguration, serializeContext);
    }
    return retVal;
  }
  get abHelpURL() {
    return this._abHelpURL;
  }
  set abHelpURL(value) {
    this._abHelpURL = value;
  }
  get activationConfiguration() {
    return this._activationConfiguration;
  }
  set activationConfiguration(value) {
    this._activationConfiguration = value;
  }
  get id() {
    return this._id;
  }
  set id(value) {
    this._id = value;
  }
  get inactivityConfiguration() {
    return this._inactivityConfiguration;
  }
  set inactivityConfiguration(value) {
    this._inactivityConfiguration = value;
  }
  get localServices() {
    return this._localServices;
  }
  set localServices(value) {
    this._localServices = value;
  }
  get pollConfiguration() {
    return this._pollConfiguration;
  }
  set pollConfiguration(value) {
    this._pollConfiguration = value;
  }
  get proxyConfiguration() {
    return this._proxyConfiguration;
  }
  set proxyConfiguration(value) {
    this._proxyConfiguration = value;
  }
}
//# sourceMappingURL=ClientSessionConfiguration.js.map
